import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule()
export class IconsModule {
    /**
     * Constructor
     */
    constructor(
        private _domSanitizer: DomSanitizer,
        private _matIconRegistry: MatIconRegistry,
    ) {
        // Register icon sets
        this._matIconRegistry.addSvgIconSet(this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));

        // Register icon sets in namespaces
        this._matIconRegistry.addSvgIconSetInNamespace('feather', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'))
            .addSvgIconSetInNamespace('iconsmind', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/iconsmind.svg'))
            .addSvgIconSetInNamespace('mat_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'))
            .addSvgIconSetInNamespace('mat_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'))
            .addSvgIconSetInNamespace('heroicons_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'))
            .addSvgIconSetInNamespace('heroicons_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'));

        // Register custom icons
        this._matIconRegistry
            .addSvgIcon('ok', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/ok.svg'))
            .addSvgIcon('vk', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/vk.svg'))
            .addSvgIcon('xing', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/xing.svg'))
            .addSvgIcon('X', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/twitter-x.svg'))
            .addSvgIcon('linkedin', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/linkedin.svg'))
            .addSvgIcon('facebook', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/facebook.svg'))
            .addSvgIcon('instagram', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/instagram.svg'))
            .addSvgIcon('post_type', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/post_type.svg'))
            .addSvgIcon('content', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/content.svg'))
            .addSvgIcon('email', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/email.svg'))
            .addSvgIcon('group', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/group.svg'))
            .addSvgIcon('confirmation', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/confirmation.svg'))
            .addSvgIcon('regular_post', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/regular_post.svg'))
            .addSvgIcon('video_post', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/video_post.svg'))
            .addSvgIcon('slack', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/slack.svg'))
            .addSvgIcon('ms_teams', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/ms_teams.svg'))
            .addSvgIcon('odnoklassniki', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/theme/icons/odnoklassniki.svg'));
    }
}
